export default {
  基础版企业主页tag: '基础版',
  标准版企业主页tag: '标准版',
  升级版企业主页tag: '升级版',
  旗舰版企业主页tag: '旗舰版',
  尊享版企业主页tag: '尊享版',
}
